export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_43-87a1e2e465e876322182f2b02f9c1dc9.jpg";